import { useTranslation } from 'react-i18next';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Api } from 'src/models/Api.model';
import CameraConnection from 'src/models/Camera/CameraConnection';
import { I18NextNS } from 'src/models/Language.model';

import { captureError } from 'src/utils/errorReporting';

export default function useCancelCaptureImages() {
  const { setIsCanceling } = useRemoteBoundStore();

  const {
    t,
    i18n: { language },
  } = useTranslation(I18NextNS.COMMON);

  const handleCancelCapture = async () => {
    try {
      setIsCanceling(true);
      await CameraConnection.getInstance().existCaptureProcess();
    } catch (error) {
      const errorMessage = t('message.error.failedToCancelCaptureImages');
      Api.alertBox({
        title: t('bootbox.title.Error'),
        message: errorMessage,
        locale: language,
        type: 'error',
      });
      captureError(error, 'Cancel capture images failed');
    }
  };

  return {
    handleCancelCapture,
  };
}
